// apps/web/src/api/lead-stages.ts — typed wrappers around the admin
//   `/api/lead-stages/*` surface (#1080). The seven canonical stage
//   codes are seeded and locked; only `displayName`, `taskTitle`, and
//   `defaultDueMinutes` are editable.
import { z } from 'zod';
import { LeadStageSchema, type LeadStage, type UpdateLeadStageInput } from '@magimp/shared';
import { request } from './client.js';

const LeadStageListResponseSchema = z.array(LeadStageSchema);

export function listLeadStages(): Promise<LeadStage[]> {
  return request<LeadStage[]>('/lead-stages', { method: 'GET' }, {}, LeadStageListResponseSchema);
}

export function patchLeadStage(code: string, body: UpdateLeadStageInput): Promise<LeadStage> {
  return request<LeadStage>(
    `/lead-stages/${encodeURIComponent(code)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    LeadStageSchema,
  );
}
